module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAsCAMAAABIQohxAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAADBQTFRF2Ori0+Xc8vLyytrR6uvr6fLszdLP3+zl+/z84+/o29zc7vXxzt3W9vj33u7p////GVYjjgAAAQFJREFUeNp00lkChCAIAFAQ9/X+tx21UrDGz16sCq0ZMO19oEOt6NIHhNoPYCgnuHodgJA+YZhjEICB3mDY94pqA0tUa2Y1gGeKDBSyTJpBYUCegWElIh8wfGcSEdlz0PjV7ChOu1u5RFyDoARtV0wQoGiFQPm79r+QOES2FPD8zvmNuPMxvOp30CBkgyIOzzDjhyhD/IIjxC1oWcA1zATxUu5lTjASZv0JSeaaw0wI1tI5zAREsrIzc0HU2mcRc4P3pSmbRa57NX0o5IIP9JmCtutigB7QLVEpKwRj27fce0f2usUjc5byeGY9QIKKdhwic8DoXOkYrXrDFdnr/QQYANXfNUSOZVbRAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/SP/assets/CA.png
// module id = /Yrv
// module chunks = 1